export class EdgeSection extends HTMLElement {
  private readonly containerElement: Map<string, HTMLDivElement> = new Map();
  private readonly edgeSection: Map<string, HTMLElement> = new Map();

  constructor() {
    super();
    this.containerElement.set("firstContainer", document.body.querySelector(".container"));
    this.edgeSection.set("closestWrapper", this.querySelector(".edge-tm"));

    this.setSpace();

    const resizeObserver = new ResizeObserver((entries) => this.setSpace());
    resizeObserver.observe(this);
  }

  private setSpace(): void {
    let space: number = this.containerElement.get("firstContainer").getBoundingClientRect().left || this.containerElement.get("firstContainer").offsetLeft;
    if (!this.firstElementChild.classList.contains("initialized")) {
      this.firstElementChild.classList.add("initialized");
    }

    this.style.setProperty("--spacing", `${space + 30}px`);
  }
}
